exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.footer[data-v-67d39c44] {\n    position: absolute !important;\n}\n", ""]);

// exports
